import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { createEmptyUser, type AuthState, type UserData, type UserResponse } from './types';
import { mergeUserFromResponse } from './workspaceLogic';
import { migrateLegacyAppStorage } from './migrateLegacyStorage';

migrateLegacyAppStorage();

type AuthActions = {
  mergeUser: (payload: UserResponse) => UserData;
  resetUser: () => void;
};

export const useAuthStore = create<AuthState & AuthActions>()(
  persist(
    (set, get) => ({
      user: createEmptyUser(),

      mergeUser: (payload) => {
        const nextUser = mergeUserFromResponse(get().user, payload);
        set({ user: nextUser });
        return nextUser;
      },

      resetUser: () => set({ user: createEmptyUser() }),
    }),
    {
      name: 'app-auth',
      partialize: (state) => ({ user: state.user }),
    }
  )
);
